<template>
  <b-card class="shadow mb-2 p-0" no-body>

    <div class="d-flex justify-content-between p-3">
      <h3 class="m-0">Integrações</h3>
      <b-button variant="link d-lg-none" v-b-toggle.integration-content>
        <i class="fas fa-chevron-circle-down"></i>
      </b-button>
    </div>

    <b-collapse id="integration-content" class="pl-3 pr-3 pb-3 " visible>
      <b-form-group :label="$t('dexpara.filtros.origem')" label-for="input-integration-origin">
        <SelectComponent
            id="input-integration-origin"
            :model="integration.origin"
            :options="integrations | idNameToValueLabel"
            :searching="isLoading"
            @input="evt => {integration.origin = evt; changed()}"
        />
      </b-form-group>
      <b-form-group :label="$t('dexpara.filtros.destino')" label-for="input-integration-destination">
        <SelectComponent
            id="input-integration-destination"
            :model="integration.destination"
            :options="integrations | idNameToValueLabel"
            :searching="isLoading"
            @input="evt => {integration.destination = evt; changed()}"
        />
      </b-form-group>
      <slot name="options"/>
      <b-button id="btn-save" type="submit" variant="success" class="w-100" @click="$emit('save')">
        <i class="fas fa-save"/> Salvar
      </b-button>
    </b-collapse>
  </b-card>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapGetters} from "vuex";
export default {
  name: "DeXParaIntegrations",
  components: {SelectComponent},
  computed: {
    ...mapGetters({
      integrations: 'integration/all',
      isLoading: 'integration/isLoading',
    })
  },
  data() {
    return {
      integration: {
        origin: null,
        destination: null
      }
    }
  },
  methods: {
    changed() {
      this.$emit('change', this.integration)
    }
  }
}
</script>